import { Box, SxProps, Theme } from "@mui/material";

type MapPanelScrollableAreaProps = {
    children: React.ReactNode;
    sx?: SxProps<Theme>;
};

export function MapPanelScrollableArea({ children, sx }: MapPanelScrollableAreaProps) {
    return <Box sx={[{ flex: 1, minHeight: 0, overflowY: "auto" }, ...(Array.isArray(sx) ? sx : [sx])]}>{children}</Box>;
}
